module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAD0kAxmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX/0kAxmdX9mdX/0kAz0kAz0kAxmdX/0kAxmdX9mdX9mdX9mdX/0kAybf1SVD0joAAAAFXRSTlMAnxDPn++/j0Agj4BgvyCAcECvUN/PivQNAAAA5UlEQVR4Xu3V3XLCMAyE0Y0dyfkzNLRK3/9Ny5Un0ELHyl6Bvwc4s7oS3rZhvqiYqM6fAe7GXmxXXLyM3fcBR4vYrzyTbuZ8zcM1OAp7RxZ4C3HnxJHkBJIDjiOkPTaTHAskJ5IcU5JjSnJMSY4pyTFjOd9dnZFM0p/OtnXHthTnKlGcKik9duokeehUSk+cIjlPiyrFqZBCf8voCKDbHBL6+ydIkRJYEkiSgCQlcKQeIEjFOSYlsQQQpFKT/q9JTWpSk5o00aQTSzqDJGWQpAySNIEkreBIHQ42kRzgdM55WvHi/QA6YV/CcfzmHAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f528.png
// module id = 1115
// module chunks = 0